import { RouteRecordRaw } from "vue-router";
import { HOME_URL, LOGIN_URL, MATCH_NAME } from "@/config";

/**
 * staticRouter (静态路由)
 */
export const staticRouter: RouteRecordRaw[] = [
    {
        path: "/",
        redirect: HOME_URL
    },
    {
        path: LOGIN_URL,
        name: "login",
        component: () => import("@/views/pages/login/index.vue"),
        meta: {
            title: "登录"
        }
    },
    {
        path: LOGIN_URL + "/:tenantId",
        name: "tenantLogin",
        component: () => import("@/views/pages/login/index.vue"),
        meta: {
            title: "登录"
        }
    }
];

/**
 * errorRouter (错误页面路由)
 */
export const errorRouter = [
    {
        path: "/403",
        name: "403",
        component: () => import("@/views/components/ErrorMessage/403.vue"),
        meta: {
            title: "403页面"
        }
    },
    {
        path: "/404",
        name: "404",
        component: () => import("@/views/components/ErrorMessage/404.vue"),
        meta: {
            title: "404页面"
        }
    },
    {
        path: "/500",
        name: "500",
        component: () => import("@/views/components/ErrorMessage/500.vue"),
        meta: {
            title: "500页面"
        }
    },
    // Resolve refresh page, route warnings
    {
        path: "/:pathMatch(.*)*",
        name: MATCH_NAME,
        component: () => import("@/views/components/ErrorMessage/404.vue")
    }
];
